// Basic consent mode: no Google script or request until an explicit opt-in.
const banner = document.querySelector('[data-analytics-consent]')
if (banner) {
  const key = 'site-hush.analytics-consent.v1'
  const lifetime = 180 * 24 * 60 * 60 * 1000
  const id = banner.dataset.measurementId
  const settings = document.querySelector('[data-analytics-settings]')
  let started = false
  let choice
  try {
    const saved = JSON.parse(localStorage.getItem(key))
    if (saved?.expires > Date.now() && ['granted', 'denied'].includes(saved.choice))
      choice = saved.choice
  } catch {
    // Storage can be blocked. Never infer consent from a storage failure.
  }

  const start = () => {
    if (started || !/^G-[A-Z0-9]+$/.test(id)) return
    started = true
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
      window.dataLayer.push(arguments)
    }
    const gtag = window.gtag
    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
    })
    gtag('consent', 'update', { analytics_storage: 'granted' })
    gtag('js', new Date())
    // Trusted SSR canonical URL only: no query, fragment, input, tenant or user ID.
    // Referrer origin only: private return paths must never enter Analytics.
    let referrer = ''
    try {
      const origin = new URL(document.referrer).origin
      if (origin !== location.origin) referrer = origin
    } catch {
      // Empty or invalid referrer.
    }
    gtag('config', id, {
      send_page_view: false,
      page_location: banner.dataset.pageUrl,
      page_referrer: referrer,
      page_title: document.title,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      cookie_domain: 'none',
      cookie_expires: lifetime / 1000,
      cookie_flags: 'SameSite=Lax;Secure',
    })
    gtag('event', 'page_view', { send_to: id })
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    script.nonce = document.querySelector('script[nonce]')?.nonce || ''
    script.referrerPolicy = 'no-referrer'
    document.head.append(script)
  }

  const revoke = () => {
    window[`ga-disable-${id}`] = true
    // Analytics cookies are host-only. Do not touch login/session cookies.
    for (const cookie of document.cookie.split(';')) {
      const name = cookie.trim().split('=')[0]
      if (/^_ga(?:_|$)/.test(name))
        document.cookie = `${name}=;Max-Age=0;Path=/;SameSite=Lax;Secure`
    }
    // Unload the already running vendor script; the next document remains blocked.
    window.location.reload()
  }

  // A withdrawal in another public tab must also stop an already loaded tag.
  window.addEventListener('storage', (event) => {
    if (!started || (event.key && event.key !== key)) return
    try {
      const saved = JSON.parse(event.newValue)
      if (saved?.choice === 'granted' && saved.expires > Date.now()) return
    } catch {
      // A missing/invalid preference is never consent.
    }
    revoke()
  })

  const showChoice = () => {
    banner.hidden = false
    if (!banner.open) banner.showModal()
  }
  const hideChoice = () => {
    banner.close()
    banner.hidden = true
  }
  settings.hidden = false
  settings.addEventListener('click', showChoice)
  banner.addEventListener('cancel', (event) => {
    event.preventDefault()
    hideChoice() // Escape dismisses without granting or changing consent.
  })
  for (const button of banner.querySelectorAll('[data-analytics-choice]')) {
    button.addEventListener('click', () => {
      choice = button.dataset.analyticsChoice
      try {
        localStorage.setItem(key, JSON.stringify({ choice, expires: Date.now() + lifetime }))
      } catch {
        // Explicit opt-in may apply to this page without a persistent preference.
      }
      hideChoice()
      if (choice === 'granted') start()
      else if (started) revoke()
    })
  }
  if (choice === 'granted') start()
  if (!choice) showChoice()
}
